import { inject, InjectionToken } from '@angular/core';
import { createClient } from '@supabase/supabase-js';

import { AUTH_CONFIG } from './auth-config.token';

export const SUPABASE = new InjectionToken('@sona/angular-auth-domain.supabase', {
    factory: () => {
        const { supabaseUrl, supabaseAnonKey } = inject(AUTH_CONFIG);

        return createClient(supabaseUrl, supabaseAnonKey);
    }
});
